export interface Cambio {
  id: string;
  codigo: string;
  titulo: string;
  descripcion: string;
  estado: string;
  prioridad: string;
  impacto: string;
  riesgo: string;
  usuarioCreacion: string;
  fechaCreacion: string;
  fechaActualizacion: string;
  fechaEjecucion: string;

  //
  tipoCambio: string;
  fechaProgramada: string;   // "yyyy-MM-dd"
  horaProgramada: string;    // "HH:mm:ss"
  duracion: string;          // "HH:mm:ss"
  serviciosAfectados: ServicioAfectadoRequest[];
  planAccion: PlanAccionRequest[];
  riesgos: RiesgoCambioRequest[];
  rollbackActividades: RollbackActividadRequest[];
}

export interface CambioPagingRes {
  data: Cambio[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  first: boolean;
  last: boolean;
}

export type GetCambiosParams = Partial<Cambio> & {
  page?: number;
  size?: number;
  estado?: string;
  prioridad?: string;
  usuarioCreacion?: string;
  [key: string]: any;
}

export type CreateCambios = Omit<Cambio, 'id'>
// export type CreateCambiosForm = CrearCambioRequest & {
//   aprobadorPorArea? : Record<string, number>
// };
export type CreateCambiosForm = {
  titulo: string;
  descripcion: string;
  prioridad: string;
  impacto: string;
  riesgo: string;
  tipoCambio: string;
  fechaProgramada: string;
  horaProgramada: string;
  duracion: string;
  //
  solicitante: string;
  areasAfectas: string[];

  serviciosAfectados: {
    tiempoAfectacion: string;
    clienteAfectado: string;
    servicio: string;
  }[];

  planAccion: {
    accion: string;
    responsable: string;
    fecha: string;
    observacion: string;
  }[];

  riesgos: {
    descripcion: string;
    impacto: string;
    probabilidad: string;
    tipoRiesgo: string;
    accionContingencia: string;
  }[];

  rollbackActividades: {
    actividad: string;
    duracion: string;
    responsable: string;
  }[];
  //
    // aprobadoresPorArea: {
    //   areaId: string;
    //   aprobadorId: number | '';
    // }[];
    aprobadores: { areaId: string; aprobadorId: number | '' }[];
    responsableIds: string[];
    notificacionIds: string[];
};


export interface CrearCambioRequest {
  titulo: string;
  descripcion: string;
  prioridad: string;
  impacto: string;
  riesgo: string;
  areasAfectas: string[];
  aprobadoresIds: number[];
  solicitante: string;
  aprobadores: { areaId: string; aprobadorId: number }[];
  ///
  tipoCambio: string;
  fechaProgramada: string;   // "yyyy-MM-dd"
  horaProgramada: string;    // "HH:mm:ss"
  duracion: string;          // "HH:mm:ss"
  serviciosAfectados: ServicioAfectadoRequest[];
  planAccion: PlanAccionRequest[];
  riesgos: RiesgoCambioRequest[];
  rollbackActividades: RollbackActividadRequest[];
  responsableIds: string[];
  notificacionIds: string[];


}

export interface ServicioAfectadoRequest {
  tiempoAfectacion: string;  // "HH:mm:ss"
  clienteAfectado: string;
  servicio: string;
}

export interface PlanAccionRequest {
  accion: string;
  responsable: string;
  fecha: string;             // "yyyy-MM-dd"
  observacion: string;
}

export interface RiesgoCambioRequest {
  descripcion: string;
  impacto: string;
  probabilidad: string;
  tipoRiesgo: string;
  accionContingencia: string;
}

export interface RollbackActividadRequest {
  actividad: string;
  duracion: string;          // "HH:mm:ss"
  responsable: string;
}

export interface MetricaCumplimientoRequest {
  descripcion: string;
  cumplido: boolean;
  observacion?: string;
}


/////
// === Respuestas del GET by ID (con IDs) ===
export interface ServicioAfectadoResponse {
  servicioAfectadoId: string;
  tiempoAfectacion: string;
  clienteAfectado: string;
  servicio: string;
}

export interface MetricasResponse {
  metricaId: string;
  descripcion: string;
  cumplido: string;
  observacion: string;
}

export interface PlanAccionResponse {
  planAccionId: string;
  accion: string;
  responsable: string;
  fecha: string;
  observacion: string;
}

export interface RiesgoCambioResponse {
  riesgoCambioId: string;
  descripcion: string;
  impacto: string;
  probabilidad: string;
  tipoRiesgo: string;
  accionContingencia: string;
}

export interface RollbackActividadResponse {
  rollbackActividadId: string;
  numero: number;
  actividad: string;
  duracion: string;
  responsable: string;
}

export interface CambioResponse {
  id: string;
  codigo: string;
  titulo: string;
  descripcion: string;
  estado: string;
  prioridad: string;
  impacto: string;
  riesgo: string;
  usuarioCreacion: string;
  fechaCreacion: string;
  fechaActualizacion: string;
  tipoCambio: string;
  fechaProgramada: string;
  horaProgramada: string;
  solicitante: string;
  duracion: string;
  serviciosAfectados: ServicioAfectadoResponse[];
  metricas? : MetricasResponse[];
  planAccion: PlanAccionResponse[];
  riesgos: RiesgoCambioResponse[];

  rollbackActividades: RollbackActividadResponse[];
  // --- recuperados al editar ---
  areasAfectas?: string[];
  notificacionIds?: string[];
  responsableIds?: string[];
  aprobadores?: { areaId: string; usuarioId: number }[];
}

////PARA LA IMPLEMENTACION DE CAMBIOS POR PERSONA

export const adaptAprobaciones = (resp: any) => {
  const r = resp as AprobacionPagingRes;

  return {
    aprobaciones: r?.data ?? [],
    totalElements: r?.totalElements ?? 0,
    page: r?.page ?? 0,
    size: r?.size ?? 10,
    totalPages: r?.totalPages ?? 0,
    first: r?.first ?? false,
    last: r?.last ?? false,
  };
};

export interface AprobacionPagingRes {
  data: Aprobacion[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  first: boolean;
  last: boolean;
}
export interface Aprobacion {
  aprobacionId: string;
  cambioId: string;
  codigo: string;
  codigoCambio: string;
  area: { areaId: string; nombre: string; descripcion?: string };
  usuarioId?: number;
  estadoAprobacion: 'PENDIENTE' | 'APROBADO' | 'RECHAZADO';
  comentario: string | null;
  fechaCreacion: string;
  fechaActualizacion: string;
  fechaRespuesta: string | null;
}

export interface ResponderAprobacionRequest {
  estadoAprobacion: 'APROBADO' | 'RECHAZADO';
  comentario: string;
}

///UPDATE

export interface ActualizarCambioRequest {
  titulo: string;
  descripcion: string;
  prioridad: string;
  impacto: string;
  riesgo: string;
  estado: string;
  tipoCambio: string;
  fechaProgramada: string;
  horaProgramada: string;
  duracion: string;
  serviciosAfectados: ServicioAfectadoRequest[];
  planAccion: PlanAccionRequest[];
  riesgos: RiesgoCambioRequest[];
  rollbackActividades: RollbackActividadRequest[];
}

export interface CambiarEstadoRequest {
  estado: string;
  metricas?: MetricaCumplimientoRequest[];
}



export interface ResponsableResponse {
  responsableId: string;
  cargo: string;
  usuarioId: number;
  estado: boolean;
  correo: string;
  telefono: string;
}

export interface NotificacionResponse {
  notificacionId: string;
  nombre: string;
  correo: string;
  estado: boolean;
}